import { useEffect, useState } from 'react'
import { CONFIG } from './config'

export default function Loader({ done, onGone }) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (done) {
      setProgress(100)
      const id = setTimeout(() => onGone?.(), 180)
      return () => clearTimeout(id)
    }

    let rafId = 0
    const start = performance.now()
    const totalMs = CONFIG.loader.minMs

    const tick = (now) => {
      const raw = Math.min((now - start) / totalMs, 1)
      const eased = 5 + raw * 89
      setProgress(Math.round(Math.min(eased, 94)))

      if (raw < 1) {
        rafId = requestAnimationFrame(tick)
      }
    }

    rafId = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(rafId)
  }, [done, onGone])

  return (
    <div className={`pr-loader${done ? ' is-done' : ''}`} role="status" aria-live="polite" aria-label="Loading">
      <div className="pr-loader__panel">
        <div className="pr-loader__value" aria-live="polite">{progress}%</div>
        <div className="pr-loader__bar-wrap" aria-hidden="true">
          <div className="pr-loader__bar" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  )
}
